import React from 'react';
import { Content, Box } from 'reactjs-admin-lte';
import Pagination from 'components/core/Pagination';
import MHTJobListTable from './MHTJobListTable';
import MHTJobListFilter from './MHTJobListFilter';

const MHTJobList = (props) => {
  
  const {
    jobs,
    client,
    status,
    keyword,
    messageState,
    handleKeywordChange,
    handleClientChange,
    handleStatusChange,
    handleMessageStateChange,
    handleSubmit,
    isLoading,
    currentPage,
    pageSize,
    handlePageSelect,
    handleTabOpen
  } = props;
  
  return (
    <Content.Body>
      <MHTJobListFilter
        status={status}
        client={client}
        keyword={keyword}
        messageState={messageState}
        handleSubmit={handleSubmit}
        handleStatusChange={handleStatusChange}
        handleKeywordChange={handleKeywordChange}
        handleClientChange={handleClientChange}
        handleMessageStateChange={handleMessageStateChange} />
      <Box
        className="box-widget mb-0"
        loading={isLoading}>
        <Box.Body noPadding={true}>
          <MHTJobListTable
            jobs={jobs}
            handleTabOpen={handleTabOpen} />
        </Box.Body>
        <Box.Footer>
          <Pagination
            currentPage={currentPage}
            totalPages={pageSize}
            onChange={handlePageSelect} />
        </Box.Footer>
      </Box>
    </Content.Body>
  );
}

export default MHTJobList;
